<template>
  <el-popover
    placement="bottom"
    title=""
    width="480"
    popper-class="setting-popover"
    trigger="hover">
    <div class="agent-content">
      <div>
        <p>{{$t('tvuAgent')}}:</p>
        <span v-html="$t('agentDownloadTips', { url: initConfig.homeUrl })"></span>
      </div>
    </div>
    <a :href="initConfig.homeUrl"
       slot="reference"
       class="a-button"
       target="_blank"><i class="iconfont icon-resource"></i></a>
  </el-popover>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AgentDowloadPopover',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      initConfig: 'initConfig'
    })
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.a-button {
  text-decoration: none;
  color: #fff;
}
.icon-resource {
  font-size: 17px;
  cursor: pointer;
}
</style>
